import { makeActionCreator } from '../../util/make_action_creator'

export const SET_COMPONENT_VALID = 'SET_COMPONENT_VALID'
export const SET_COMPONENT_INVALID = 'SET_COMPONENT_INVALID'
export const INVALIDATE_ALL = 'INVALIDATE_ALL'

export const setComponentValid = makeActionCreator(SET_COMPONENT_VALID, 'keys')
export const setComponentInvalid = makeActionCreator(
  SET_COMPONENT_INVALID,
  'keys',
)
export const invalidateAll = makeActionCreator(INVALIDATE_ALL)
